import React, { Fragment, Component } from "react";
import { useSearchParams } from 'react-router-dom';
import ChalanFormView from "../HelperChunks/ChalanFormView";
import LoginMenu from "../../../../components/LoginMenu/LoginMenu";
import CircularProgress from "@mui/material/CircularProgress";
import ReactToPrint from "react-to-print";
import { Button } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

class TutionFeeChalanForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chalanData: {},
      isLoginMenu: false,
      isReload: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    const query = this.props.searchParams;

    if (query != null && query.get("_t") != null && query.get("_t") != "") {
      this.setState({
        isLoading: true,
      });
      let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C116FinanceStudentsLegacyFeePendingVoucherView`;
      await fetch(url, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + query.get("_t"),
        }),
      })
        .then((res) => {
          if (!res.ok) {
            throw res;
          }
          return res.json();
        })
        .then((json) => {
          if (json.CODE === 1) {
            if (json.DATA) {
              if (json.DATA.length > 0) {
                this.setState({
                  chalanData: json.DATA[0] || {},
                });
              }
            }
          } else {
            alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
          }
        })
        .catch((error) => {
          if (error.status == 401) {
            window.location = "#/close-mobile-challan-view";
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            alert("Operation Failed, Please try again later.");
          }
          console.log(error);
        });
      this.setState({
        isLoading: false,
      });
    } else {
      window.location = "#/close-mobile-challan-view";
    }
  };

  render() {
    return (
      <Fragment>
        <ReactToPrint
          trigger={() => {
            return (
              <center>
                <div style={{ marginTop: 20, fontWeight:"bold" }}>Please click below button for print fee challan</div>
                <br />
                <Button
                  style={{
                    marginTop: 15,
                    marginRight: 20,
                    textTransform: "capitalize",
                  }}
                  color="primary"
                  variant="contained"
                >
                  <PrintIcon style={{ paddingRight: 5 }} /> Print Fee Challan
                </Button>
                <div style={{ marginTop: 20, fontWeight:"bold" }}>After print challan form you can close the browser</div>
              </center>
            );
          }}
          content={() => this.componentRef}
          pageStyle="@page { size: landscape; margin: 0mm;}"
        />
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        {this.state.isLoading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "20%",
              alignItems: "center",
            }}
          >
            <CircularProgress size={35} />
            <span style={{ marginTop: 10 }}>Please Wait...</span>
          </div>
        ) : (
            <div style={{ display: "none"}}>
          <div
            ref={(el) => (this.componentRef = el)}
            style={{
              display: "flex",
              justifyContent: "space-around",
              fontFamily: "inherit",
              marginTop: 50,
            }}
            
          >
            <ChalanFormView
              data={this.state.chalanData}
              feeCard="School Copy"
            />
            <ChalanFormView data={this.state.chalanData} feeCard="Bank Copy" />
            <ChalanFormView
              data={this.state.chalanData}
              feeCard="Parent Copy"
            />
          </div>
          </div>
        )}
      </Fragment>
    );
  }
}

// HOC to inject useSearchParams into class component
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let [searchParams] = useSearchParams();
    return <Component {...props} searchParams={searchParams} />;
  }
  return ComponentWithRouterProp;
}

export default withRouter(TutionFeeChalanForm);
